import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import VwOrgYetkiKullaniciDTO from "src/models/Base/Yetki/VwOrgYetkiKullaniciDTO";
import VwVezneKullanicimapDTO from "src/models/Base/Yetki/VwVezneKullanicimapDTO";
import { GridState } from "src/models/GridState";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import orgkullaniciService from "src/services/OrganizasyonYetki/orgkullanici.service";
import VezneKullaniciMapService from "src/services/Yetki/VezneKullaniciMapService";

export interface IVezneYetkiState {
    kullanici: GridState<VwOrgYetkiKullaniciDTO>,
    vezneKullanici: GridState<VwVezneKullanicimapDTO>,
    organizasyonId: number
}

export const getKullaniciByOrganizasyon = createAsyncThunk(
    'orgkullaniciService/getKullaniciByOrganizasyon',
    async (organizasyonId: number) => {
        const response = await orgkullaniciService.getKullaniciByOrganizasyon(organizasyonId)
        return response
    }
)
export const getVezneKullanici = createAsyncThunk(
    'VezneKullaniciMapService/getVezneByKullanici',
    async (userId: number) => {
        const response = await VezneKullaniciMapService.getVezneByKullanici(userId)
        return response
    }
)
const VezneYetkiSlice = createSlice<IVezneYetkiState, MapReducerPayloads<IVezneYetkiState, {
    setState: IVezneYetkiState
}>>({
    name: 'VezneYetkiSlice',
    initialState: {
        kullanici: {
            ...new GridState<VwOrgYetkiKullaniciDTO>(),
            activeRow: new VwOrgYetkiKullaniciDTO(),
            isFetching: true
        },
        vezneKullanici: {
            ...new GridState<VwVezneKullanicimapDTO>(),
            activeRow: new VwVezneKullanicimapDTO(),
            isFetching: true
        },
        organizasyonId: 0
    },
    reducers: {
        setState: (state, action) => action.payload
    },
    extraReducers: (builder) => {
        builder.addCase(getKullaniciByOrganizasyon.pending, (state, { payload }) => {
            state.kullanici.isLoading = true
        })
        builder.addCase(getKullaniciByOrganizasyon.fulfilled, (state, action) => {
            state.kullanici.data = action.payload.data || []
            state.kullanici.activeRow = new VwOrgYetkiKullaniciDTO()
            state.kullanici.isLoading = false
            state.kullanici.isFetching  = false
        })
        builder.addCase(getVezneKullanici.pending, (state, { payload }) => {
            state.vezneKullanici.isLoading = true
        })
        builder.addCase(getVezneKullanici.fulfilled, (state, action) => {
            state.vezneKullanici.data = action.payload.data || []
            state.vezneKullanici.activeRow = new VwVezneKullanicimapDTO()
            state.vezneKullanici.errorMessage = action.payload.errorMessage
            state.vezneKullanici.isLoading= false
        })
    }
})
export default VezneYetkiSlice;